{
  "catalogue": {
    "searchPlaceholder": "Item name or code",
    "resultCount": "Results: {{count}}",
    "emptyNone": "No items are available to your purchasing unit yet",
    "emptyHint": "Check the spelling, or clear the search and filters to see every item.",
    "pageEmpty": "No items on this page",
    "firstPage": "Go to the first page",
    "noResults": "No results for this search"
  }
}
